import { render, staticRenderFns } from "./InputOTP.vue?vue&type=template&id=4408fa96&scoped=true"
import script from "./InputOTP.vue?vue&type=script&lang=js"
export * from "./InputOTP.vue?vue&type=script&lang=js"
import style0 from "./InputOTP.vue?vue&type=style&index=0&id=4408fa96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4408fa96",
  null
  
)

export default component.exports